import React from 'react';
import Modal from '@/components/ui/Modal';
import Button from '@/components/ui/Button';
import { OneTimerTask } from '../types';
import { useDeleteTask } from '../api/oneTimersApi';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  task: OneTimerTask;
}

const DeleteConfirmationModal: React.FC<Props> = ({ isOpen, onClose, task }) => {
  const deleteTaskMutation = useDeleteTask();

  const handleDelete = async () => {
    try {
      await deleteTaskMutation.mutateAsync(task.id);
      onClose();
    } catch (error) {
      console.error('Failed to delete task:', error);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Delete Task" maxWidth="sm">
      <div className="space-y-4">
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0">
            <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>
          <div>
            <h3 className="text-lg font-medium text-gray-900">Are you sure?</h3>
            <p className="text-sm text-gray-500 mt-1">
              This will permanently delete "{task.title}". This action cannot be undone.
            </p>
          </div>
        </div>

        <div className="flex gap-3 pt-4">
          <Button variant="outline" className="flex-1" onClick={onClose} disabled={deleteTaskMutation.isPending}>Cancel</Button>
          <Button variant="danger" className="flex-1" onClick={handleDelete} disabled={deleteTaskMutation.isPending}>
            {deleteTaskMutation.isPending ? 'Deleting...' : 'Delete'}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal; 